import { Link, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";

export const FloatingExpertButton = () => {
  const location = useLocation();
  // Hide on the experts page itself (already there)
  if (location.pathname === "/experts") return null;

  return (
    <div className="expert-fab-wrap fixed bottom-5 right-5 z-[60]">
      <Link to="/experts" data-testid="floating-talk-expert">
        <div className="expert-fab relative inline-flex items-center gap-2 rounded-full bg-black text-white pl-3 pr-4 py-3 shadow-2xl hover:opacity-90 transition-opacity">
          <span className="expert-dot h-2.5 w-2.5 rounded-full bg-white shrink-0" />
          <MessageCircle className="h-5 w-5" />
          <span className="font-body font-semibold text-sm whitespace-nowrap">Talk to Expert</span>
        </div>
      </Link>
    </div>
  );
};
